// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"866ce651","453":"7e0e010d"}[chunkId] + ".chunk.js";
};